import { Box } from '@mui/material'

interface SignUpStepHeaderProps {
  steps: any
  activeStep: number
}

export default function SignUpStepHeader({ steps, activeStep }: SignUpStepHeaderProps) {
  return (
    <div className='w-full'>
      <Box display='flex' alignItems='center' justifyContent='center' sx={{ mb: 4 }} className='gap-2 sm:gap-0'>
        {steps.map((step: any, index: number) => (
          <Box key={step.label} display='flex' alignItems='center' className='w-full'>
            <div className='flex flex-col items-center gap-2 w-full'>
              <div>
                {activeStep > index && (
                  // Completed step: show checkmark SVG
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10.5" cy="10" r="10" fill="#3551F2" />
                    <path d="M6.4165 10L9.33317 12.9167L15.1665 7.08333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                )}
                {activeStep === index && (
                  // Active step: show filled blue circle (customize as needed)
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10.5" cy="10" r="10" fill="#3551F2" />
                    <circle cx="10.5" cy="10" r="7" fill="white" />

                  </svg>
                )}
                {activeStep < index && (
                  // Inactive step: show outlined circle
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10.5" cy="10" r="10" fill="#3551F2" fillOpacity="0.16" />
                    <circle cx="10.5" cy="10" r="7" fill="white" />

                  </svg>
                )}
              </div>


              <div className='md:block'>
                <div className='text-[#4B465C] text-[15px] font-semibold'>{step.label}</div>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className='w-[88px] h-[3px] bg-[#3551F229] sm:block' />

            )}
          </Box>
        ))}
      </Box>
    </div>
  )
}
